import { Link } from "react-router-dom";
import { setConsent, useConsent } from "../../lib/hooks";

export function CookieBanner() {
  const c = useConsent();
  if (c) return null;
  return (
    <div role="region" aria-label="Preferenze cookie" className="fixed bottom-0 inset-x-0 z-[60] p-3 sm:p-4" data-testid="cookie-banner">
      <div className="container-x"><div className="card-line shadow-lg p-4 sm:p-5 flex flex-col md:flex-row md:items-center gap-4">
        <p className="text-sm flex-1">Il sito usa solo cookie tecnici necessari. Strumenti facoltativi (mappa OpenStreetMap) vengono caricati solo con il tuo consenso. <Link to="/cookie" className="underline">Dettagli</Link></p>
        <div className="flex gap-2 flex-wrap">
          <button className="tap px-4 rounded-md bg-primary text-primary-foreground font-medium" onClick={() => setConsent({ map: false })} data-testid="cookie-necessary-btn">Solo necessari</button>
          <button className="tap px-4 rounded-md bg-primary text-primary-foreground font-medium" onClick={() => setConsent({ map: true })} data-testid="cookie-accept-btn">Accetta mappa</button>
        </div>
      </div></div>
    </div>
  );
}

export function OsmMap({ lat, lon }) {
  const c = useConsent();
  const q = encodeURIComponent("Via Cavour 9, 33097 Spilimbergo PN");
  const links = (
    <p className="text-sm mt-3">Indicazioni: <a className="underline" href={`https://www.openstreetmap.org/search?query=${q}`} target="_blank" rel="noopener noreferrer">apri su OpenStreetMap</a></p>
  );
  if (!c?.map || !lat || !lon) {
    return (
      <div className="card-line p-6 bg-secondary/50" data-testid="map-placeholder">
        <p className="font-display text-xl">Via Cavour 9 · Spilimbergo</p>
        <p className="text-sm text-muted-foreground mt-2">{!lat ? "Coordinate della mappa da impostare nel pannello amministrativo." : "La mappa interattiva è un servizio di terze parti (OpenStreetMap) e viene caricata solo con il tuo consenso."}</p>
        {lat && <button className="tap mt-4 px-4 rounded-md bg-primary text-primary-foreground text-sm font-medium" onClick={() => setConsent({ ...(c || {}), map: true })} data-testid="map-consent-btn">Carica mappa interattiva</button>}
        {links}
      </div>
    );
  }
  const d = 0.004;
  const src = `https://www.openstreetmap.org/export/embed.html?bbox=${+lon - d},${+lat - d},${+lon + d},${+lat + d}&layer=mapnik&marker=${lat},${lon}`;
  return <div><iframe title="Mappa dello studio" src={src} className="w-full h-72 border rounded-md" loading="lazy" data-testid="osm-map" />{links}</div>;
}
